import {
  SOLUTIONS_LATEST_REQUEST,
  SOLUTIONS_ME_REQUEST,
  SOLUTIONS_REQUEST,
} from '../reducers/SolutionsReducer';

export const getSolutions = (query) => ({ type: SOLUTIONS_REQUEST, query });

export const getMySolutions = (query) => ({
  type: SOLUTIONS_ME_REQUEST,
  query,
});

export const getSolutionsLatest = () => ({ type: SOLUTIONS_LATEST_REQUEST });
